/**
 * Created by Florin David on 2019-04-27.
 */
import Action, { SET_TRANSLATION } from 'constants/action-types'

export default (state = new Date().toISOString(), action: Action): string => {
  switch (action.type) {
    case SET_TRANSLATION:
      return new Date().toISOString()
    default:
      return state
  }
}
